export default {
  feeStudent: '收费学生',
  chargeItem: '收费项',
  chargeAmount: '收费项金额',
  preferentialAmount: '优惠金额',
  amountReceivable: '应收金额',
  applicableSemester: '适用学期',
  total: '合计',
  paymentAccountNumber: '付款账号',
  payOpen: '展开',
  payClose: '收起',
  totalAmount: '总金额',
  totalAmountReceivable: '应收总金额',
  totalAmountCharges: '收费项总金额',
  totalPreferentialAmount: '优惠总金额',
  chargeNumber: '收费项编号',
  accountingPeriod: '账期',
  beneficiaryName: '收款人账号名称',
  // Beneficiary name
  // Name of deposit bank
  beneficiaryBank: '开户银行名称',
  beneficiaryAccount: '收款人账号',
  newStudentPaymentNotice: '新生缴费通知',
  viewFullChargeInformation: '查看完整收费信息',
  newApplicant: '新申请人',
  pendingRequests: '待申请',
  submitApplication: '递交申请',
  homeTip: '还未正式申请，为了不影响学生的考试测评，请及时提交申请信息',
  activityName: '活动名称',
  channelName: '渠道名称',
  schoolVisitTime: '活动场次',
  activityStatus: '活动状态',
  activityInfo: '活动信息',
  wechatID: '微信号',
  applyGrade: '拟申请年级',
  student: '是否在校生',
  reMark: '留言',
  plateNumber: '车牌号',
  attendance: '出席人数',
  applicationExpired: '申请已过期',
  applicationTip: '申请已过期，请点击递交申请',
  alertTip: '未完成申请，请及时递交申请',
  addApplicants: '添加新申请人',
  chooseChildren: '选择子女',
  applyTip: '提示：同一个学生和申请过期学生不要重复填写，直接选择您要申请的学生即可。',

  changeSuccess: '修改成功',
  wxSchoolName: '无锡南外国王国际学校',
  ksSchoolName: '昆山狄邦华曜学校',
  hzSchoolName: '人大附中杭州学校',
  tsSchoolName: '测试国际学校',
  rdfzxsSchoolName: '人大附中西山学校',
  rdfztxSchoolName: '人大附中通州校区中外合作办学项目',
  rdfzsjsSchoolName: '人大附中石景山学校',
  kcscdSchoolName: '英国国王学院学校中国第三合作校狄邦肯思学校',
  exposureChannel: "最早曝光渠道",
  exposureTip: '你第一次是从哪里了解到学校的？',
  common: {
    gender: {
      male: '男',
      female: '女',
    },
    selection: {
      true: '是',
      false: '否',
    },
  },
  filter: {
    modifyTime: '最新更新时间',
    schoolVisitTime: '活动场次',
    firstDate: '首次咨询时间',
    chargesType: '收费类型',
    school: '学部',
    grade: '年级',
    birthday: '出生日期',
    applicantDate: '申请时间',
    student: '学生姓名',
    parent: '家长姓名',
    following: '跟进人',
    charges: '收费项',
    chargesNumber: '收费项编号',
    intentionality: '意向',
    enterYear: '入学年份',
    sourceName: '推荐来源',
    unfold: '展开',
    fold: '收起',
    reason: '无效/家长拒绝原因',
    studentStatus: '学生状态',
    followingStatus: '跟进状态',
    nextFollowing: '下次跟进时间',
    fileList: '清单',
    enterDate: '入学时间',
    DateOfVisit: '参观日期',
    isVisited: '活动状态',
    interviewDate: '测评时间',
    type: '类型',
    title: '标题',
    recipient: '收件人',
    sendTime: '发件时间',
    schoolYear: '学年',
    role: '角色',
    name: '姓名',
    checkStatus: '对账状态',
    paymentStatus: '订金状态',
    paidStatus: '缴费状态',
    paidTime: '缴费时间',
    depositTime: '缴订金时间',
    refundTime: '退费时间',
    sendOfferTime: '发offer时间',
    submitForm: '付款状态',
    isSendMsg: '已发送提醒',
    sender: '发件人',
    receiveTime: '收件时间',
    interview: '测评',
    parentReply: '家长回复',
    city: '城市',
    gender: '性别',
    boarding: '住宿',
    schoolBus: '校车',
    labelList: '标签',
    submitTime: '付款时间',
    activityName: '活动名称',
    enquiryDate: '咨询时间',
    childName: '孩子姓名',
    residence: '常住地',
    isEnquiry: '有咨询',
    teacherAttendance: '教师签到',
    uniformSubmitTime: '付款时间',
    applicantSubmitDate: '申请表提交时间',
    typeOfAssessment: '测评类型',
    reasonForTransfer: '转学原因',
    transferDate: '转学时间',
    class: '班级',
    channelName: '渠道名称',
    midtermExam: '中考成绩总分',
    studentType: '学生类型(户籍)',
    currentSchool: '现就读学校',
    hasBankAccount: '有银行账号',
    bankAccount: '银行账号',
    studentStatusType: '学生类型',
    studentID: '学生ID',
    createTime: '创建时间',
    semester: '学期',
    applicableSemester: '适用学期',
    orderStatus: '订单状态',
    orderType: '订单类型',
    nationality: '国籍',
    tuitionStatus: '学费状态',
    tuitionType: '学费类型',
    applicationGrade: '申请年级',
    studentGrade: '在校生年级',
    cityOfResidence: '居住城市',
    census: '户籍',
    applySection: '拟申请年级',
    statisticsTime: '统计时间',
    activityDate: '活动时间',
    collectionTime: '收款时间',
    transferTime: '转学时间',
    currentGrade: '现就读年级',
    mobile: '手机号码',
    invaildReason: '无效原因',
    isApplied: '是否提交申请表',
    yearOfApplication: '申请入学年份',
  },
  login: {
    mobileLogin: '登录',
    enterMobile: '请输入合法手机号！',
    enterMobilePlaceholder: '请输入手机号',
    countryPlaceholder: '请选择国家',
    country: '请选择国家',
    enterVerifyCode: '请输入验证码！',
    enterVerifyCodePlaceholder: '请输入验证码',
    sendVerifyCode: '获取验证码',
    resendVerifyCode: '重新获取（{timer}s）',
    login: '登录',
    loginAuto: '7天内自动登录',
    emailTitle: '联系邮箱',
    sendVerifyCodeSuccess: '验证码发送成功',
    sendVerifyCodeFail: '验证码发送失败',
    loginTip: '请登录后查看',
    accountNotExist: '该账户不存在！',
    firstLoginTip: '首次登录，我们将手机号自动注册为您的账号',
  },
  logout: '退出登录',
  backToHome: '返回首页',
  location: {
    road: '清源路188号',
    district: '滨湖区',
    city: '无锡, 江苏 214200',
    country: '中国',
  },
  admissionsContact: '招生联系人',
  router: {
    home: '首页',
    introduction: '学校介绍',
    studentDetail: '学生详情',
    userCenter: '个人中心',
    message: '消息通知',
    detail: '消息详情',
    sent: '发件箱',
    inbox: '收件箱',
    notice: '发消息',
  },
  pleaseSelect: '请选择',
  pleaseEnter: '请输入',
  pleaseEnterAddress: '请输入详细地址',
  beforeApplicantTip1: '如您希望申请{schoolName}，请填写以下《学校申请表》，并等候我们的测评通知。',
  beforeApplicantTip3: '您可在页面右上方切换语言。',
  beforeApplicantTip5: '中国籍学生请务必在中文界面填写表格。',
  beforeApplicantTip2: 'If you’d like to apply to {schoolName}, please complete the form below and wait for our notice for the interview.',
  beforeApplicantTip4: 'You can switch languages at the top right of the page.',
  beforeApplicantTip6: 'Be sure to switch the form to Chinese before filling this form if you are Chinese.',
  applicationForm: {
    basicInformation: '基础信息',
    studentInfor: '学生信息',
    parentsInfor: '家长信息',
    student: '学生信息',
    parents: '家长信息',
    addParentsInfo: '添加父母/监护人',
    applicationConfirmation: '申请确认',
    applicationConfirmationTmp: '信息确认',
    chineseName: '中文名',
    englishName: '英文名',
    studentName: '姓名',
    firstName: '名（拼音）',
    lastName: '姓（拼音）',
    nameChinese: '姓名（中文）',
    namePinyin: '姓名（拼音）',
    tip1: '中文名和英文名二选一必填',
    tip5: '姓名（中文）、姓名（拼音）和英文名均为必填项',
    tip2: '中国籍学生请填写与身份证/户口簿一致的姓名（中文），外国籍学生请填写与护照一致的姓名。',
    pinyinTip1: '示例：Wang',
    pinyinTip2: '示例：XiaoQiang',
    gender: '性别',
    male: '男',
    female: '女',
    dateOfBirth: '出生日期',
    nationality: '国籍（以护照为准）',
    language: '申请人主要使用语言',
    chinese: '中文',
    english: '英文',
    other: '其他',
    cardType: '证件类型',
    IDCard: '身份证',
    passport: '护照',
    cardNumber: '证件号码',
    applicationInfor: '申请信息',
    applicationSchool: '申请学部',
    applicationSchoolTmp: '学部',
    schoolTip: '中国籍申请人为双语学部，外籍申请人为国际学部，若需要修改学部，请联系招生老师',
    applicationYear: '申请学年',
    applicationEnterYear: '申请入学学年',
    applicationEnterYearTmp: '入学学年',
    applicationGrade: '申请年级',
    applicationGradeTmp: '年级',
    currentSection: '在读年级',
    englishLevel: '孩子的英文水平',
    parEnglishLevel: '家长可以用英文交流',
    hobby: '兴趣爱好',
    hobbyTip: '申请人是否有某些特别爱好和特长？（请按照顺序列出名称，经历，每周花费时间，参与程度，所获荣誉和奖项），如不适用，请填无',
    hobbyTipTmp: '学生是否有某些特别爱好和特长？（请按照顺序列出名称，经历，每周花费时间，参与程度，所获荣誉和奖项），如不适用，请填无',
    achievement: '学术和个人成就',
    achievementTip: '请描述申请人以往学术成就及所获荣誉，如不适用，请填无',
    achievementTipTmp: '请描述学生以往学术成就及所获荣誉，如不适用，请填无',
    tip3: '若需要修改申请年级，请联系招生老师',
    tip3Tmp: '若需要修改年级，请联系招生老师',
    tip4: '请务必对照学生户口本上的出生日期，选择申请的年级（仅针对申请{currentYear}学年的学生）',
    tip4Tmp: '请务必对照学生户口本上的出生日期，选择的年级（仅针对{currentYear}学年的学生）',
    studyingAt: '现就读学校',
    accommodation: '住宿',
    accommodationTip: '{num}至12年级可以选择住宿。',
    schoolBus: '校车',
    yes: '是',
    no: '否',
    mobile: '移动电话',
    verificationCode: '验证码',
    sendVerificationCode: '发送验证码',
    resendVerifyCode: '重新获取（{timer}s）',
    parentChineseName: '父母/监护人姓名',
    parentEnglishName: '父母/监护人英文名',
    firstGuardian: '第一监护人姓名',
    secondGuardian: '第二监护人姓名',
    relationship: '与学生的关系',
    highestEducation: '最高学历',
    graduatedSchool: '毕业院校',
    idNumber: '身份证/证件号码',
    workAddress: '工作单位详细地址',
    employer: '工作单位',
    position: '职位',
    mail: '邮箱',
    address: '居住地址',
    census: '户籍所在地',
    source: '渠道来源',
    siblingInfo: '学生的兄弟姐妹信息',
    childrenName: '孩子姓名',
    isStudyingAt: '是否为本校学生',
    addSibling: '添加兄弟姐妹',
    previous: '上一步',
    next: '下一步',
    saveToDraft: '保存至草稿',
    successSave: '保存草稿成功',
    submit: '提交',
    account: '该手机号即为你的登录账号',
    isHasSibling: '是否有兄弟姐妹',
    checkSibling: '请填写完整兄弟姐妹信息！',
    checkAddress: '请填写完整的地址信息！',
    checkAddress2: '请填写完整的户籍所在地信息！',
    checkSchoolAddress: '请填写完整的学校所在区县！',
    checkCensusAddress: '请填写完整的户口所在区县！',
    checkSchoolRoll: '请填写完整的学籍信息！',
    studentExist: '该学生已申请！',
    ageInvalid: '您的孩子年龄不符合申请条件，请联系招生老师。',
    verifyCodeWrong: '验证码错误',
    successApplicant: '申请提交成功',
    tip6: '系统已自动为你生成账号，账号为您的手机号，密码为动态验证码。',
    enterCount: '进入我的账号',
    isEmergencyContact: '是否是紧急联系人',
    emergencyContact: '紧急联系人信息',
    isFirstContact: '第一联系人',
    firstContact: '第一联系人信息',
    emergencyContactName: '姓名',
    draftTip: '保存草稿前请填写姓名或者英文名和性别！',
    draftTip2: '保存草稿前请填写姓名和性别！',
    unsubmitted: '未提交',
    unsubmittedTip: '申请表未填写完整，请及时补全',
    unsubmittedTipTmp: '信息未填写完整，请及时补全',
    hasDraftTip: '您有未提交的申请人，请先提交！',
    hasDraftTipTmp: '您有未提交的学生，请先提交！',
    userInfo: '个人信息',
    edit: '编辑',
    cancel: '取消',
    save: '保存',
    changeMobile: '修改手机号码',
    originalMobile: '原手机号码',
    newMobile: '新手机号码',
    noModifyTip: '请在个人中心修改家长信息',
    addAreaCode: '请加上区号',
    hzBoardingTip: '（六年级至高三）阶段可以选择住宿',
    schoolNowTip: '请填写就读学校全名',
    photoIsRequired: '证件照必填',
    IDIsRequired: '申请人身份证(正反面)或护照必填',
    admissionDate: '入学时间',
    accountMobile: '登录账号',
    addressTip: '地址需精确到门牌/室号',
    enNameTip: '请正确填写您孩子的英文名，入学后在相关系统注册时不再变更。',
    activityInfo: '活动信息',
    // sourcePlaceholder: {
    //   54: '请填写推荐来源',
    //   72: '请填写推荐来源',
    //   292: '请填写推荐来源',
    //   55: '请填写校方员工姓名',
    //   320: '请填写校方学生姓名',
    //   60: '请填写微信公众号',
    //   61: '请填写展会名称',
    //   62: '请填写广播报纸杂志名称',
    //   63: '请填写新闻客户端名称',
    //   64: '请填写推荐来源',
    //   123: '请填写校方员工姓名',
    //   321: '请填写校方学生姓名',
    //   128: '请填写微信公众号',
    //   129: '请填写展会名称',
    //   130: '请填写广播报纸杂志名称',
    //   131: '请填写新闻客户端名称',
    //   132: '请填写推荐来源',
    // },
    sourcePlaceholder: {
      1264: '请填写推荐来源',
      1281: '请填写推荐来源',
      1279: '请填写推荐来源',
      1280: '请填写校方员工姓名',
      741: '请填写校方学生姓名',
      1260: '请填写微信公众号',
      1139: '请填写展会名称',
      1140: '请填写广播报纸杂志名称',
      1138: '请填写新闻客户端名称',
      1141: '请填写推荐来源',
      // 1280: '请填写校方员工姓名',
      // 741: '请填写校方学生姓名',
      // 1260: '请填写微信公众号',
      1327: '请填写展会名称',
      1328: '请填写广播报纸杂志名称',
      1323: '请填写新闻客户端名称',
      // 1141: '请填写渠道来源',
      1400: '请填写校方员工姓名',
      619: '请填写校方学生姓名',
      1401: '请填写校方员工姓名',
      1214: '请填写校方学生姓名',
      637: '请填写校方员工姓名',
      1273: '请填写校方学生姓名',
      1326: '请填写校方员工姓名',
      1325: '请填写校方学生姓名',
    },
  },
  userCenter: '个人中心',
  currentStatus: '当前状态',
  delete: '删除',
  applyOnline: '在线申请',
  applyOnlineTmp: '填写信息',
  warningTip: {
    nameInvaild: '只能输入中文，且长度在1-50之间',
    pinyinNameInvaild: '必填，且长度在1-50之间，且只能输入字母',
    enNameInvaild: '必填，长度在1-50之间，且只能输入字母',
    idNumberInvaild: '证件号码必填，且长度在1-50之间',
    mobileInvaild: '手机号码必填，且均为数字',
    workUnitInvaild: '工作单位必填，且长度在1-50之间',
    positionInvaild: '职位必填，且长度在1-50之间',
    addressInvaild: '地址必填，且长度在1-50之间',
    schoolNowExtraInvaild: '现在就读学校必填，且长度在1-50之间',
    siblingNameInvaild: '孩子姓名必填，且长度在1-50之间',
    leaveFromForm: '离开此网站？系统可能不会保存您所做的更改！',
    schoolExtraInvaild: '长度不超过50个字符',
    valueLen150: '长度不超过150个字符',
    remarkInvaild: '长度不超过2000个字符',
    vCodeNotNull: '验证码不能为空',
    originalMobileWrong: '原手机号不正确',
    modifyMobileSuccess: '修改成功',
    tip404: '抱歉，你访问的页面不存在',
    tip500_1: '抱歉，您指定的网页无法访问。',
    tip500_2: '您可以扫码添加招生小助手咨询。',
    applicantSuccess: '申请表提交成功！',
    numberInvaild: '必填，且均为数字',
    rankingInvaild: '请填写数字或者名次/人数',
    valueInvalid: '必填，且长度为1-50字符',
    numberLenInvaild: '必填，且长度为1-50个数字',
    valueNumInvaild: '必填，且长度为1-100字符',
    contentNotEmpty: '内容不能为空',
    enquiryMobileInvaild: '请填写正确的手机号',
    emailInvaild: '请输入合法邮箱',
    scoreInvaild: '请填写数字或者无',
    valueNotMoreThen10: '不超过10个字符',
  },
  confirmSubmit: '确认提交申请表？',
  confirmSubmitTmp: '确认提交信息表？',
  // confirmSubmitTip: '提交后，申请表将不能修改，若要修改请联系招生老师',
  confirmSubmitTip: '提交后，若需修改申请信息，请至首页，点击学生卡片，进入学生信息页进行修改。',

  confirmSubmitTipTmp: '提交后，信息表将不能修改，若要修改请联系招生老师',
  sendMessage: '发消息',
  MessageColumns: {
    no: '序号',
    type: '类型',
    title: '标题',
    sendBy: '发件人',
    sendTime: '发件时间',
    content: '内容',
    recipent: '收件人',
    receiveTime: '收件时间',
  },
  uploadFile: '上传文件',
  upload: '上传',
  checklist: '附件清单',
  checklistTip: '清单提交后，将不能删除，文件或图片10M以内',
  checklistTip2: '（请在测评前提交清单）',
  fileTip: '文件或图片10M以内',
  file1: '申请人身份证(正反面)或护照',
  file1Tmp: '学生身份证（正反面）或护照',
  file1Tip: '无身份证者请上传申请人户口本页',
  file1TipTmp: '无身份证者请上传学生户口本页',
  file2: '家长或监护人身份证(正反面)或护照',
  file3: '申请人近6个月电子版证件照（2寸）',
  file3Tmp: '学生近6个月电子版证件照（2寸）',
  file4: '证件文件',
  file4Tip: '申请人过去2学年的成绩单、学年证书和其他相关证书',
  file4TipTmp: '学生过去2学年的成绩单、学年证书和其他相关证书',
  file5: '疫苗证明',
  file5Tip: '2年级以上不需要提交',
  chooseFile: '选择文件',
  ok: '确认',
  cancel: '取消',
  signin: '签到',
  uploadSuccess: '上传成功',
  fileTypeErr: '文件类型错误！',
  fileSizeErr: '文件大小不超过10M',
  fileSize30MErr: '文件大小不超过10M',
  todoTip: '您有{num}个未完成清单',
  newMessageTip: '收到{num}条新的消息',
  message: '消息通知',
  receiveTime: '收件时间',
  sendBy: '发件人',
  msgContent: '消息内容',
  attachment: '附件',
  attachmentTip: '附件大小10M以内,最多添加10个.',
  picTip: '图片大小10M以内,最多添加10个.',
  remark: '备注',
  remarkInfo: '备注信息',
  uniformBook: '服装预定',
  paymentRecord: '缴费记录',
  uniformTip: '（2020/05/01前学生的服装尺寸和付款人信息，可以进行修改）',
  height: '身高(cm)',
  weight: '体重(kg)',
  size: '服装尺码',
  payerInfo: '付款人信息',
  payerName: '付款人姓名',
  payerMobile: '付款人电话',
  bankAccount: '付款人银行账号',
  bankName: '付款人开户行名称',
  alipay: '支付宝账号',
  email: '邮件',
  certificate: '凭证',
  paymentMethod: '付款方式',
  uniformPrice: '（服装定金为8000元）',
  payByAlipay: '支付宝扫码付款',
  bankTransfer: '银行转账',
  payerTip: '（确保与付款账户相一致）',
  uniformTable: '身高体重尺码推荐表',
  uniformSizeTip: '推荐家长基于“身高、体重”等信息，选择“适度偏大一点”的服装尺码；如需更大，请在备注栏内填写所需尺码。',
  uniformTip3: '请填写详细家庭地址，招生老师会给您邮寄重要材料。',
  uniformTip1: '若通过其他方式转账，请填写无',
  uniformTip2: '若通过银行转账，请填写无',
  uploadReceipt: '上传回执凭证',
  uploadTip: '（上传后，将不能删除）',
  receiptTemplate: '凭证模版',
  fillUniformInfo: '填写服装信息',
  submitSuccess: '提交成功',
  signInSuccess: '签到成功',
  recipient: '收件人',
  title: '标题',
  content: '内容',
  addRecipient: '添加收件人',
  send: '发送',
  selectRecipient: '请选择收件人',
  sendSuccess: '发送成功',
  replyMsg: '回复',
  receiveBy: '收件人',
  sendTime: '发件时间',
  studentList: '教师列表',
  selectedStud: '已选择{num}人',
  deleteAll: '删除全部',
  stuNum: '（{num}人）',
  selectAll: '全选',
  sender: '发件人',
  messageTable: {
    type: '类型',
    title: '标题',
    content: '内容',
    toMember: '收件人',
  },
  resourceNotEmpty: '回执凭证不能为空',
  uploadPic: '上传图片',
  uniformSubmitTip: '亲爱的家长，你已提交成功，后续会有招生老师联系你，感谢你的配合与静候。',
  payeeConfirm: '请确认收款方为：',
  loadingMore: '加载更多',
  loginTip: '同一家庭申请多个小孩，登录/注册务必使用同一个手机号码',
  activityInvaild1: '活动未开始～',
  activityInvaild: '活动已失效～',
  activityError: '暂无活动～',
  activityInvaildTip: '活动报名有效期为：{startTime} - {endTime}',
  enquiryWelcome: '欢迎报名 “{activityName}”',
  censusRegister: '户籍',
  schoolRoll: '学籍',
  IDCard: '身份证号',
  currentGade: '现就读年级',
  emailTip: '该邮箱用于接收重要信息',
  examResults: '考试成绩',
  gradeOfThirdGrade: '初三上期末成绩总分',
  gradeOfThirdGradeRank: '初三上期末年级排名',
  firstSimulationResults: '一模成绩总分',
  firstSimulationRank: '一模区排名',
  secondSimulationResults: '二模成绩总分',
  secondSimulationRank: '二模区排名',
  juniorHighSchoolResult: '中考成绩总分',
  districtRanking: '中考区排名',
  subject: '中考选考科目（五选三）',
  biochemistry: '生化',
  physical: '物理',
  history: '历史',
  geography: '地理',
  political: '政治',
  eachScores: '中考分科成绩（含体育）',
  eachScoresTip: '请填写语文、数学、英语卷面、英语口语、三项选考科目及体育课成绩',
  standardizedScore: '标准化考试',
  standardizedScoreTip: '暂无成绩，写“无”，后期可以补全成绩',
  toefl: '托福',
  ielts: '雅思',
  others: '其他',
  personalDisplay: '个人展示',
  hobbies: '爱好特长',
  awards: '获奖情况',
  hobbies1: '你最喜欢或对你影响最深的一本书/一档节目/一个爱好',
  choiceReason: '你为什么选择{schoolName}AP项目？',
  qualities: '你认为自己的哪些特质符合{schoolName}？',
  resume: '个人简历',
  rankInputFormat: '名次/人数',
  studentType: '学生类型（户籍）',
  registrationNumber: '北京中考报名号',
  workAddress: '工作单位',
  schoolAddress: '学校所在区县',
  censusAddress: '户口所在区县',
  homeAddress: '家庭地址',
  nation: '民族',
  member: '是否团员',
  completeScores: '补全成绩',
  completeBankInfo: '登记中信银行卡信息',
  accountParentName: '开户家长姓名',
  accountParentIDNumber: '开户家长身份证号',
  accountTip: '请确保信息正确，提交后将不能修改',
  bankInfo: '中信银行卡信息',
  subjectInvaild: '请选择三项中考选考科目',
  applicationNotes: '报名须知',
  stuName: '学生姓名',
  stuGender: '学生性别',
  stuBirthday: '学生出生日期',
  stuIdNumber: '学生身份证号码',
  wechatTip: '加微信小助手，获取更多信息',
  awardsOrHonors: '国内外获奖及荣誉，国外学习经历等最能体现学生能力的信息',
  questionAboutSchool: '你想要了解我校哪些方面的信息',
  suggestion: '你对我校发展的建议（或者你认为我校需要改进和加强的方面）',
  questionAboutAdmission: '你想要咨询有关招生的哪些问题',
  resumeTip: '请上传pdf格式，30M以内',
  confirmSubmit2: '确认提交？',
  submitTip: '提交后学生基础信息不可修改，考试成绩如：一模、二模、中考、标准化考试成绩可以修改补全。',
  downloadApplicant: '打印现场确认单',
  orderDetailTable: {
    charges: '收费项',
    chargeAmount: '收费项金额（元）',
    discount: '优惠金额（元）',
    amountReceivable: '应收金额（元）',
    applicableSemester: '适用学期',
    operation: '操作',
    studentName: '学生姓名',
    grade: '申请年级',
    school: '学部',
    enterYear: '申请学年',
    creator: '创建人',
    createTime: '创建时间',
  },
  otherFee: '其他费用',
  orderTable: {
    name: '学生姓名',
    id: '学生ID',
    bankAccount: '银行账号',
    grade: '年级',
    charges: '收费项',
    totalCharges: '收费项总金额（元）',
    totalDiscount: '优惠总金额（元）',
    totalReceivable: '应收总金额（元）',
    createTime: '创建时间',
    totalPaid: '已付总金额（元）',
    totalOwed: '欠缴总金额（元）',
    orderStatus: '订单状态',
    orderNumber: '订单编号',
    orderType: '订单类型',
  },
  tip: {
    noVisitTime: '该学部暂无活动场次',
    fullVisitTime: '已约满，时间待定',
  },
};
